import React from 'react';

export const PrimaryNavigationContext = React.createContext({
	openedTab: null,
	setOpenedTab: (arg: any) => {},
});
